<template>
	<Head title="Aula teste"></Head>
	<meeting_iframe
		:jitsi_domain="props.jitsi_domain"
		:token_jwt="props.token_jwt"
		:room_name="props.room_name" />
</template>

<script setup lang="ts">
	import { onBeforeMount } from 'vue';
	import meeting_iframe from '../../../components/Class/meeting_iframe.vue';
	import { menuStore } from '../../../stores/menu';
	import { Head } from '@inertiajs/vue3';

	const props = defineProps({
		room_name: { type: String, required: true },
		token_jwt: { type: String, required: true },
		jitsi_domain: { type: String, required: true },
	});

	onBeforeMount(() => {
		menuStore().isMeetingPage();
	});
</script>
